import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'btp-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.css']
})
export class BadgeComponent implements OnInit {
  @Input() size: "small" | "medium" | "large" | "xlarge" = "medium";
  @Input() color: "dark-green" | "light-green" | "red" | "yellow" = "dark-green";
  @Input() position: "center" | "left" | "right" = "left";

  constructor() { }

  ngOnInit() {
  }

}
